import React from "react";
import ReactDOM from "react-dom";

import { GalleryModal } from "components";
import { getRenderRoot, RenderRoot } from "utils";
import { IVideo } from "types";

const videoBlocks = document.querySelectorAll("[data-video-block]");
const MODAL_ROOT = getRenderRoot(RenderRoot.modal);

videoBlocks.forEach((videoBlock) => {
  const videoTeasers = videoBlock.querySelectorAll<HTMLElement>(
    "[data-video-teaser]"
  );

  if (!videoTeasers) return;

  const videos: IVideo[] = Array.from(videoTeasers).map((slide) => {
    const data = slide.dataset.videoTeaser;
    slide.dataset.videoTeaser = ""; // cleanup

    if (!data) return undefined;

    return JSON.parse(data);
  });

  videoTeasers.forEach((videoTeaser, index) => {
    videoTeaser.addEventListener("click", () => {
      ReactDOM.render(
        <GalleryModal videos={videos} initIndex={index} />,
        MODAL_ROOT
      );
    });
  });
});

export {};
